import { TwoStoreyHouse } from "game-common/room/ember/two_storey_house"

/** Only room changes within a declared parent/children graph share live artwork. */
export const isRelatedFloorTransfer = (fromRoomId: string | undefined, from: TwoStoreyHouse | undefined,
    toRoomId: string, to: TwoStoreyHouse | undefined): boolean => {
    if (!fromRoomId || fromRoomId === toRoomId || !from?.groundRoomId || from.groundRoomId !== to?.groundRoomId) return false
    const rooms = (house: TwoStoreyHouse) => house.floorRoomIds ?? [house.groundRoomId, house.upperRoomId]
    return rooms(from).includes(fromRoomId) && rooms(from).includes(toRoomId) &&
        rooms(to).includes(fromRoomId) && rooms(to).includes(toRoomId)
}
